import Vue from 'vue';

Vue.mixin({
  computed: {
    selectedPhotos() {
      return this.myOrder ? this.myOrder.photos : [];
    },
    balance() {
      if ('3-default-more-photos' === this.orderStep) {
        const limitFrom = this.productItem.limitFrom;
        return limitFrom > this.selectedPhotos.length
            ? limitFrom - this.selectedPhotos.length : 0;
      } else {
        if (this.bulkPrice) {
          return +this.bulkPrice.quantity > this.selectedPhotos.length
              ? +this.bulkPrice.quantity - this.selectedPhotos.length : 0;
        }
      }

      return 0;
    },
    steps() {
      return {
        '1': {
          title: this.album && this.album.title ?
              this.album.title :
              this.$t('no_name'),
          info: this.photo && +this.coreParams.current_shop_package.shop_package.filenames ? `<ul class="info-list"><li class="info-filename">${this.photo.photo_file_name}</li><li class="info-date">${this.photo.date_taken_original ? this.$options.filters.moment(this.photo.date_taken_original, 'DD.MM.YYYY HH:mm') : ''}</li></ul>` : '',
        },
        '2': {
          title: this.$t('select_your_product'),
        },
        '2-view': {
          title: this.$t('overview'),
        },
        '3-set': {
          title: this.$t('sets'),
        },
        '3-set-confirm': {
          title: this.$t('confirm_your_product'),
        },
        '3-digital': {
          title: this.$t('products'),
        },
        '3-digital-confirm': {
          title: this.$t('confirm_your_product'),
        },
        '3-digital-variants': {
          title: this.$t('choose_variant'),
        },
        '3-digital-bulk-prices': {
          title: this.$t('choose_bulk_price'),
        },
        '3-digital-more-photos': {
          title: this.$t('select_more_photos'),
          info: this.productItem
              ?
              `${this.selectedPhotos.length}${this.bulkPrice ?
                  ` / ${this.bulkPrice.quantity}+` :
                  ''} ${this.$tc('photos_selected', this.selectedPhotos.length)}`
              :
              '',
        },
        '3-default': {
          title: this.$t('products'),
        },
        '3-default-confirm': {
          title: this.$t('confirm_your_product'),
        },
        '3-default-variants': {
          title: this.$t('choose_variant'),
        },
        '3-default-more-photos': {
          title: this.$t('select_more_photos'),
          info: this.$tc('photos_selected_amount', this.selectedPhotos.length, {amount: this.productItem
              ? `${this.selectedPhotos.length}${this.productItem.limitFrom ||
              this.productItem.limitTo ? ` / ${this.productItem.limitFrom &&
              this.productItem.limitTo && this.productItem.limitTo >
              this.productItem.limitFrom
                  ? `${this.productItem.limitFrom}-${this.productItem.limitTo}`
                  : `${this.productItem.limitFrom
                      ? `${this.productItem.limitFrom}+`
                      : this.productItem.limitTo
                          ? this.productItem.limitTo
                          : '?'}`}` : ''}`
              : null}),
        },
        '4': {
          title: this.$t('check_your_order'),
          info: this.$tc('photos_selected_amount', this.myOrder ? this.myOrder.quantity : 0, {
            amount: this.myOrder ? this.myOrder.quantity : 0,
          }),
        },
      };
    },
  },
  methods: {
    getAlbumId() {
      return this.album.status === '2'
          ? `${this.album.hash}-${this.album.hash_password}`
          : this.album.id;
    },
    selectSets(sets) {
      this.$store.dispatch('SET_SETS', sets);
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);

      if (sets.sets.length === 1) {
        this.$store.dispatch('SET_PRODUCT_SET', this._.first(sets.sets));
        this.$store.dispatch('SET_ORDER_STEP', '3-set-confirm');
      } else {
        this.$store.dispatch('SET_ORDER_STEP', '3-set');
      }
    },
    selectProductCategory(product) {
      product.items.map((item) => {
        item.uuid !== 'undefined' && delete item.uuid;
        return item;
      });

      let photos = this.selectedPhotos.filter(photo => photo && !+photo.not_for_sale);

      this.$store.dispatch('SET_PHOTOS', photos);
      this.$store.dispatch('ADD_PREV_ORDER_STEP', this.orderStep);
      this.$store.dispatch('SET_PRODUCT', product);
      this.$store.dispatch('SET_ORDER_STEP', `3-${product.slug}`);
    },
    getAspectRatio(photo, sizes) {
      const imgWidth = JSON.parse(photo.dimensions).width;
      const imgHeight = JSON.parse(photo.dimensions).height;

      let result = 0;

      if (sizes.width && sizes.height) {
        const cropBoxData = photo.processing.cropper.cropBoxData;

        if (cropBoxData) {
          result = cropBoxData.width / cropBoxData.height;
        } else if (imgWidth >= imgHeight) {
          if (+sizes.width > +sizes.height) {
            result = +sizes.width / +sizes.height;
          } else {
            result = +sizes.height / +sizes.width;
          }
        } else if (imgWidth < imgHeight) {
          if (+sizes.width < +sizes.height) {
            result = +sizes.width / +sizes.height;
          } else {
            result = +sizes.height / +sizes.width;
          }
        }
      }

      return result;
    },
    async closeOrder() {
      if (this.uuid) {
        this.$router.push(this.i18nLink('cart'));
      } else {
        if (this.album && this.$store.getters.ORDER_FAVORITE_PHOTOS) {
          this.$store.dispatch('SET_ORDER_FAVORITE_PHOTOS', false);
          this.$router.push(this.i18nLink(`selected/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}`));
        } else if (this.album && this.$store.getters.SHOW_FAVORITE_PHOTO) {
          this.$store.dispatch('SET_SHOW_FAVORITE_PHOTO', false);
          this.$router.push(this.i18nLink(`selected/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}`));
        } else if (this.album && this.$route.name !== 'cart') {
          this.$router.push(this.i18nLink(`album/gallery/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}${this.$store.getters.ALBUM_TAG ? `/tag/${this.$store.getters.ALBUM_TAG}` : ''}`));
          /*this.$nextTick(() => {
            const albumPhotos = this.albumPhotos;

            this.$store.dispatch('SET_ALBUM_PHOTOS', []);
            this.$store.dispatch('SET_ALBUM_PHOTOS', albumPhotos);
          });*/
        }
      }

      this.$store.dispatch('DROP_ORDER');
    },
    async closeOrderSet() {
      history.replaceState(null, null, ' ');

      this.$store.dispatch('SET_SET', null);

      if (!this.myOrder || this.myOrder && !this.myOrder.photos.length) {
        if (this.uuid) {
          this.$router.push(this.i18nLink('cart'));
        } else {
          this.$router.push(this.i18nLink(`album/gallery/${this.album.status === '2' ? `${this.album.hash}-${this.album.hash_password}` : this.album.id}${this.$store.getters.ALBUM_TAG ? `/tag/${this.$store.getters.ALBUM_TAG}` : ''}`));
        }
      }
    },
  },
});

